import React, { useEffect } from 'react';
import './TrojanModalCover.scss';

interface Props {
  onReset: () => void;
  children: React.ReactNode;
  title: string;
  footer: React.ReactNode;
  size?: 'sm' | 'md' | 'lg';
}

const TrojanModalCover: React.FC<Props> = ({ onReset, children, title, footer, size = 'md' }) => {
  useEffect(() => {
    const handler = (e: MouseEvent) => {
      const modal = document.querySelector('.trojan-modal-cover');
      if (modal && modal.contains(e.target as Node)) {
        e.stopPropagation();
        e.preventDefault();
      }
    };
    document.addEventListener('dblclick', handler, true);
    return () => document.removeEventListener('dblclick', handler, true);
  }, []);

  return (
    <div className="trojan-modal-cover" onClick={onReset}>
      {/* Modal Content */}
      <div
        className={`trojan-modal-content trojan-modal-content--${size}`}
        style={{ zIndex: 100001 }}
        onClick={e => e.stopPropagation()}
      >
        {/* Header */}
        <div className="trojan-modal-header">
          <h5 className="trojan-modal-title">{title}</h5>
          <button
            className="trojan-modal-close"
            onClick={onReset}
            onMouseEnter={e => {
              e.currentTarget.classList.add('hover');
            }}
            onMouseLeave={e => {
              e.currentTarget.classList.remove('hover');
            }}
          >
            ×
          </button>
        </div>

        {/* Body */}
        <div className="trojan-modal-body">{children}</div>

        {/* Footer */}
        <div className="trojan-modal-footer">{footer}</div>
      </div>
    </div>
  );
};

export default TrojanModalCover;
